module.exports = __webpack_public_path__ + "img/weikaishi.ea500108.png";